import { getIntegrationDisplayName, IntegrationServiceId } from '../../common/integrations'

export const getCrossClientIntegrationDisplayName = (serviceId: IntegrationServiceId): string =>
  serviceId === IntegrationServiceId.E_MONEY ? 'Financial Planning' : getIntegrationDisplayName(serviceId)
